import { createAsyncThunk } from '@reduxjs/toolkit';
import { REPORTS } from '../../constant';
import { getToken } from '../../Utils/authUtils';

interface Payload {
  reportId: string;
  userId: string;
}

/**
 * Record who performed the scan on a report.
 *
 * Separate from `assignReportToDoctor` on purpose: assigning a cardiologist moves the
 * report between worklists and pulls a Draft to Preliminary, whereas naming the
 * sonographer only records a fact about the study.
 */
export const setReportSonographer = createAsyncThunk(
  'setReportSonographer',
  async (payload: Payload, { rejectWithValue }) => {
    try {
      const token = getToken();
      const res = await fetch(REPORTS.SET_SONOGRAPHER, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
        const errorData = await res.json();
        return rejectWithValue(errorData.message || 'Failed to update sonographer');
      }

      return await res.json();
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
